import { ApiClient } from '../../../api/api-client';
import { Administracion } from '../../../models/Administracion';
import { Consorcio } from '../../../models/Consorcio';

export const APIGeneralSales = {

  getAdministraciones: (url): Promise<Administracion[]> => {
    return ApiClient.getApiRecursos(url)
      .then(resp => {
        const administraciones = [];

        // Trabajo los submodelos que tiene
        resp.data.forEach((admin) => {
          let nueva_admin = new Administracion();
          nueva_admin.setDataFromApi(admin);
          administraciones.push(nueva_admin);
        });

        return administraciones;
      });
  },

  getConsorciosAdministracion: (url): Promise<Consorcio[]> => {
    return ApiClient.getApiRecursos(url).then(resp => {
      const consorcios = [];

      resp.data.forEach((consorcio) => {
        let nuevo_consorcio = new Consorcio();
        nuevo_consorcio.setDataFromApi(consorcio);
        consorcios.push(nuevo_consorcio);
      });

      return consorcios;

    });
  }

};